import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { filterReducer } from './components/filter';
import { scheduleReducer } from './components/schedule';
import { moduleReducer } from './modules';
import { vkReducer } from './components/vk';
import { nearTicketsReducer } from './components/nearTickets';
import { tooltipReducer } from './components/tooltip';

export default () => combineReducers({
    module: moduleReducer,
    filter: filterReducer,
    schedule: scheduleReducer,
    vk: vkReducer,
    form: formReducer,
    nearTickets: nearTicketsReducer,
    tooltips: tooltipReducer
});
